import { apiService } from './index';
import {
    IRegisterPerson,
    IRegisterTipificationCosmos,
} from '../shared/types/caseReport';

export const asyncGetPerson = async (typeId?: string, numerId?: string) => {
    return await apiService.get(`/api/person/${typeId}/${numerId}`);
};

export const asyncGetTipification = async (
    parentId?: string,
    type?: string,
    process?: string,
    digitalWindow?: number
) => {
    return await apiService.get(`/api/param/getTipification`, {
        parentId: parentId || '',
        type: type || '',
        process: process || '',
        digitalWindow: digitalWindow || '',
    });
};

export const asyncPostPerson = async (formPerson: IRegisterPerson) => {
    return await apiService.post('/api/person', formPerson);
};

export const asyncPatchtPerson = async (
    id: string,
    formPerson: IRegisterPerson
) => {
    return await apiService.put(`/api/person/${id}`, formPerson);
};

export const asyncPostTipificationCosmos = async (
    formTipificationCosmos: IRegisterTipificationCosmos
) => {
    return await apiService.post(
        '/api/param/createTipificationCosmos',
        formTipificationCosmos
    );
};

export const asyncGetHistorical = async (
    document: string,
    page?: number,
    pageSize?: number
) => {
    return await apiService.get(`/api/param/getCases/${document}`, {
        limit: pageSize || 20,
        page: page || 0,
    });
};
